import * as React from "react";
import { themePalette } from "../../theme";

export const ClearSearchIcon = ({
  color = themePalette.greyMedium,
  onClick,
}: React.SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width="25"
    height="25"
    style={{ marginLeft: "-35px", cursor: "pointer", zIndex: 10 }}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M6.438 13.562C6.618 13.7427 6.82967 13.833 7.073 13.833C7.31633 13.833 7.528 13.7427 7.708 13.562L10 11.271L12.292 13.562C12.472 13.7427 12.6837 13.833 12.927 13.833C13.1703 13.833 13.389 13.7427 13.583 13.562C13.7637 13.368 13.8507 13.1493 13.844 12.906C13.8367 12.6633 13.7427 12.4517 13.562 12.271L11.292 10L13.583 7.708C13.7637 7.528 13.854 7.31633 13.854 7.073C13.854 6.82967 13.7637 6.611 13.583 6.417C13.389 6.23633 13.1703 6.146 12.927 6.146C12.6837 6.146 12.472 6.23633 12.292 6.417L10 8.708L7.688 6.396C7.52133 6.22933 7.31633 6.146 7.073 6.146C6.82967 6.146 6.618 6.23633 6.438 6.417C6.25733 6.59767 6.167 6.80933 6.167 7.052C6.167 7.29533 6.25733 7.50733 6.438 7.688L8.729 10L6.417 12.312C6.25033 12.4787 6.167 12.6837 6.167 12.927C6.167 13.1703 6.25733 13.382 6.438 13.562ZM10 18.5C8.81933 18.5 7.71167 18.2777 6.677 17.833C5.64233 17.389 4.743 16.785 3.979 16.021C3.215 15.257 2.611 14.3577 2.167 13.323C1.72233 12.2883 1.5 11.1807 1.5 10C1.5 8.81933 1.72233 7.71167 2.167 6.677C2.611 5.64233 3.215 4.743 3.979 3.979C4.743 3.215 5.64233 2.611 6.677 2.167C7.71167 1.72233 8.81933 1.5 10 1.5C11.1807 1.5 12.2883 1.72233 13.323 2.167C14.3577 2.611 15.257 3.215 16.021 3.979C16.785 4.743 17.389 5.64233 17.833 6.677C18.2777 7.71167 18.5 8.81933 18.5 10C18.5 11.1807 18.2777 12.2883 17.833 13.323C17.389 14.3577 16.785 15.257 16.021 16.021C15.257 16.785 14.3577 17.389 13.323 17.833C12.2883 18.2777 11.1807 18.5 10 18.5Z"
      fill={color}
    />
  </svg>
);
